import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);
// 用按需加载的方式配置路由
const Layout = () => import("@/views/layout");
const home = () => import("@/views/home/home");
const richTextParsing = () => import("@/views/richTextParsing/richTextParsing");
const excellentStationRichText = () => import("@/views/excellentStationRichText/excellentStationRichText");
const canteenMLogin = () => import("@/views/canteenForM/login.vue");
const scanVerify = () => import("@/views/canteenForM/scanVerify.vue");
const verifyRecord = () => import("@/views/canteenForM/verifyRecord.vue");
const canteenUserLogin = () => import("@/views/canteenForUser/login.vue");
const eatCode = () => import("@/views/canteenForUser/eatCode.vue");
const eatRecord = () => import("@/views/canteenForUser/eatRecord.vue");
// 站长中心
const centerHome = () => import("@/views/center/centerHome/centerHome");
const moreContent = () => import("@/views/center/moreContent/moreContent");
const perfect = () => import("@/views/center/perfect/perfect");
const detail = () => import("@/views/center/detail/detail");
const login = () => import("@/views/center/login/login");
const questionIndex = () => import("@/views/question/questionIndex.vue");
const questionList = () => import("@/views/question/questionList.vue");
const questionDetail = () => import("@/views/question/detail.vue");
// 务工档案  站长端
const migrantFilesLogin = () => import("@/views/migrantFiles/stationmaster/login");
const migrantFilesHome = () => import("@/views/migrantFiles/stationmaster/home");
const migrantFilesJobDetail = () => import("@/views/migrantFiles/stationmaster/jobDetail");
const migrantFilesRecruitDetail = () => import("@/views/migrantFiles/stationmaster/recruitDetail");
const migrantFilesCompanyDetail = () => import("@/views/migrantFiles/stationmaster/companyDetail");
const migrantFilesGrant = () => import("@/views/migrantFiles/migrantFilesGrant");
const migrantFilesSelectPersonnel = () => import("@/views/migrantFiles/stationmaster/selectPersonnel");


// 务工档案  用户端
const migrantFilesMyJobInfo = () => import("@/views/migrantFiles/user/myJobInfo");
const migrantFilesMyJobEdit = () => import("@/views/migrantFiles/user/myJobEdit")
const migrantFilesmyJobDetail = () => import("@/views/migrantFiles/user/myJobDetail");
const empty = () => import("@/views/migrantFiles/user/empty");
// 新年活动
const springActivity = () => import("@/views/springActivity/springActivityNew");

// 通用微信登录
const passport = () => import("@/views/home/passport");
const receiveCode = () => import("@/views/home/receive_code");

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

VueRouter.prototype.replace = function replace(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: "/",
    name: "home",
    component: home
  },
  {
    path: "/passport",
    name: "passport",
    component: passport
  },
  {
    path: "/receiveCode",
    name: "receiveCode",
    component: receiveCode
  },
  {
    path: "/richTextParsing",
    name: "richTextParsing",
    component: richTextParsing
  },
  {
    path: "/springActivity",
    name: "springActivity",
    component: springActivity,
  },
  {
    path: "/canteenForM/login",
    component: canteenMLogin,
    meta: {
      title: "登录"
    }
  },
  {
    path: "/canteenForM/scanVerify",
    component: scanVerify,
    meta: {
      title: "扫码核销"
    }
  },
  {
    path: "/canteenForM/verifyRecord",
    component: verifyRecord,
    meta: {
      title: "核销记录"
    }
  },
  {
    path: "/canteenForUser/login",
    component: canteenUserLogin,
    meta: {
      title: "登录",
      contentName: "viewport",
      content:
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover, user-scalable=0"
    }
  },
  {
    path: "/canteenForUser/eatCode",
    component: eatCode,
    meta: {
      title: "就餐码",
      contentName: "viewport",
      content:
        "width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, viewport-fit=cover, user-scalable=0"
    }
  },
  {
    path: "/canteenForUser/eatRecord",
    component: eatRecord,
    meta: {
      title: "就餐记录"
    }
  },
  //站长中心
  {
    path: "/stationCenter/centerHome",
    name: "centerHome",
    component: centerHome,
    meta: {
      title: "站长中心"
    },
  },
  {
    path: "/stationCenter/centerHome",
    name: "centerHome",
    component: centerHome,
    meta: {
      title: "站长中心"
    },
  },
  {
    path: "/stationCenter/moreContent",
    name: "moreContent",
    component: moreContent,
    meta: {
      title: "站长中心",
      isAlive: true,
      isBack: false
    }
  },
  {
    path: "/stationCenter/perfect",
    name: "perfect",
    component: perfect,
    meta: {
      title: "站长中心"
    }
  },
  {
    path: "/stationCenter/detail",
    name: "detail",
    component: detail,
    meta: {
      title: "站长中心"
    }
  },
  {
    path: "/stationCenter/login",
    name: "login",
    component: login,
    meta: {
      title: "站长中心"
    }
  },
  //站长中心over
  // 务工档案
  {
    path: "/migrantFiles/login",
    name: "migrantFilesLogin",
    component: migrantFilesLogin,
    meta: {
      title: "站长认证"
    }
  },
  {
    path: "/migrantFiles/home",
    name: "migrantFilesHome",
    component: migrantFilesHome,
    meta: {
      title: "务工档案"
    }
  },
  {
    path: "/migrantFiles/jobDetail",
    name: "jobDetail",
    component: migrantFilesJobDetail,
    meta: {
      title: "求职档案"
    }
  },
  {
    path: "/migrantFiles/recruitDetail",
    name: "recruitDetail",
    component: migrantFilesRecruitDetail,
    meta: {
      title: "职位详情"
    },

  },
  {
    path: "/migrantFiles/companyDetail",
    name: "companyDetail",
    component: migrantFilesCompanyDetail,
    meta: {
      title: "公司详情"
    },
  },
  {
    path: "/migrantFiles/selectPersonnel",
    name: "selectPersonnel",
    component: migrantFilesSelectPersonnel,
    meta: {
      title: "人员选择"
    }

  },
  {
    path: "/migrantFiles/migrantFilesGrant",
    name: "migrantFilesGrant",
    component: migrantFilesGrant,
    meta: {
      title: "授权"
    }
  },

  {
    path: "/migrantFiles/myJobInfo",
    name: "myJobInfo",
    component: migrantFilesMyJobInfo,
    meta: {
      title: "我的务工信息",
      isAlive: true,
    }
  },
  {
    path: "/migrantFiles/myJobEdit",
    name: "myJobEdit",
    component: migrantFilesMyJobEdit,
    meta: {
      title: "务工信息录入",
      isAlive: true,
    },
  },
  {
    path: "/migrantFiles/myJobDetail",
    name: "myJobDetail",
    component: migrantFilesmyJobDetail,
    meta: {
      title: "务工信息详情"
    }
  },
  {
    path: "/migrantFiles/empty",
    name: "empty",
    component: empty,
    meta: {
      title: "务工信息详情"
    }
  },



  {
    path: "/question",
    name: "question",
    component: Layout,
    children: [
      {
        path: "index",
        component: questionIndex,
        meta: { isAlive: true, title: '争霸题库' }
      },
      {
        path: "list",
        component: questionList,
        meta: { isAlive: true, title: '搜索结果' }
      },
      {
        path: "detail",
        component: questionDetail
      }
    ]
  },

  // 标杆站长富文本解析
  {
    path: "/excellentStationRichText",
    name: "excellentStationRichText",
    component: excellentStationRichText
  },
];

const router = new VueRouter({
  routes
});

export default router;
